import Container from './container'

export default function MetodoSolveProblems() {
  return (
    <section className="text-white bg-[#040116]">
      <Container className="flex flex-col lg:flex-row lg:items-center justify-between gap-28 py-18 md:py-24">
        <img
          src="../assets/metodo-imagem.png"
          alt=""
          className="block aspect-square lg:aspect-auto"
        />
        <div className="space-y-5 max-w-[609px] px-4 md:px-0">
          <h2 className="font-inter-regular text-[32px] md:text-5xl text-center md:text-left leading-[1.2]">
            Método <br />
            <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
              Solve Problems
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-center md:text-left">
            <strong>
              Todo grande desafio esconde uma oportunidade de inovação.
            </strong>{' '}
            Nós aplicamos o método Solve Problems para transformar problemas
            complexos em soluções inteligentes, que geram valor real e
            impulsionam a eficiência do seu negócio.
          </p>
        </div>
      </Container>
    </section>
  )
}
